import { MenuConfigItem } from 'components/common/SideMenu/SideMenu';

type DashboardConfigKey = 'portfolio' | 'project' | 'excellenceApps';

export const dashboardConfig: Record<DashboardConfigKey, MenuConfigItem> = {
    portfolio: {
        name: 'Portfolio',
        title: 'Portfolio',
        link: 'portfolio',
    },
    project: {
        name: 'Project',
        title: 'Project',
        link: 'project',
    },
    excellenceApps: {
        name: 'Excellence Apps',
        title: 'Excellence Apps',
        link: 'program',
    },
};
